export const defaultAxisLabelsStyle = {
  labels: {
    style: {
      fontSize: '10px',
      fontWeight: '400',
      color: '#000',
    },
  },
};

export const CHART_WEEKEND_FILL = '#F2F2F2';
